const _c0 = ["*"];
export * from 'primeng/types/fluid';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, inject, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { BaseComponent, PARENT_INSTANCE } from 'primeng/basecomponent';
import * as i1 from 'primeng/bind';
import { Bind } from 'primeng/bind';
import { BaseStyle } from 'primeng/base';
const classes = {
  root: 'p-fluid'
};
let FluidStyle = /*#__PURE__*/(() => {
  class FluidStyle extends BaseStyle {
    name = 'fluid';
    classes = classes;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFluidStyle_BaseFactory;
      return function FluidStyle_Factory(__ngFactoryType__) {
        return (ɵFluidStyle_BaseFactory || (ɵFluidStyle_BaseFactory = i0.ɵɵgetInheritedFactory(FluidStyle)))(__ngFactoryType__ || FluidStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FluidStyle,
      factory: FluidStyle.ɵfac
    });
  }
  return FluidStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Fluid is a layout component to make descendant components span full width of their container.
 *
 * [Live Demo](https://www.primeng.org/fluid/)
 *
 * @module fluidstyle
 *
 */
var FluidClasses = /*#__PURE__*/function (FluidClasses) {
  /**
   * Class name of the root element
   */
  FluidClasses["root"] = "p-fluid";
  return FluidClasses;
}(FluidClasses || {});
const FLUID_INSTANCE = /*#__PURE__*/new InjectionToken('FLUID_INSTANCE');
/**
 * Fluid is a layout component to make descendant components span full width of their container.
 * @group Components
 */
let Fluid = /*#__PURE__*/(() => {
  class Fluid extends BaseComponent {
    componentName = 'Fluid';
    $pcFluid = inject(FLUID_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptms(['host', 'root']));
    }
    _componentStyle = inject(FluidStyle);
    static ɵfac = /* @__PURE__ */(() => {
      let ɵFluid_BaseFactory;
      return function Fluid_Factory(__ngFactoryType__) {
        return (ɵFluid_BaseFactory || (ɵFluid_BaseFactory = i0.ɵɵgetInheritedFactory(Fluid)))(__ngFactoryType__ || Fluid);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Fluid,
      selectors: [["p-fluid"]],
      hostVars: 2,
      hostBindings: function Fluid_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.cx("root"));
        }
      },
      features: [i0.ɵɵProvidersFeature([FluidStyle, {
        provide: FLUID_INSTANCE,
        useExisting: Fluid
      }, {
        provide: PARENT_INSTANCE,
        useExisting: Fluid
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function Fluid_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [CommonModule],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Fluid;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FluidModule = /*#__PURE__*/(() => {
  class FluidModule {
    static ɵfac = function FluidModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FluidModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FluidModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [Fluid]
    });
  }
  return FluidModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Fluid, FluidClasses, FluidModule, FluidStyle };
